import * as yup from 'yup';

export const validation = yup.object().shape({
  cli_email: yup.string().email("Email inválido").required("El email es obligatorio")
});
